import { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { Volume2 } from "lucide-react";
import { api, fmtTime } from "@/lib/api";
import { beep } from "@/pages/Delivery";
import { cn } from "@/lib/utils";

export default function PublicPanel() {
  const { slug } = useParams();
  const [d, setD] = useState(null);
  const [flash, setFlash] = useState(false);
  const [audio, setAudio] = useState(false);
  const lastKey = useRef(null);
  useEffect(() => {
    document.documentElement.classList.add("dark");
    const load = () => api.get(`/public/panel/${slug}`).then((r) => {
      const key = r.data.current ? `${r.data.current.code}-${r.data.current.last_call_at}` : null;
      if (lastKey.current !== null && key && key !== lastKey.current) {
        setFlash(true);
        if (audio) beep();
        setTimeout(() => setFlash(false), 4000);
      }
      lastKey.current = key || "";
      setD(r.data);
    });
    load();
    const t = setInterval(load, 3000);
    return () => clearInterval(t);
  }, [slug, audio]);
  if (!d) return <div className="min-h-screen bg-slate-950" />;
  const c = d.current;
  return (
    <div className="min-h-screen bg-slate-950 text-white grid lg:grid-cols-3" data-testid="public-ticket-panel">
      <div className={cn("lg:col-span-2 flex flex-col items-center justify-center p-10 transition-colors duration-500", flash ? "bg-blue-600" : "bg-slate-900")}>
        <p className="font-mono text-sm uppercase tracking-[0.3em] text-blue-200">{d.store} · Senha chamada</p>
        <p className={cn("font-mono font-extrabold leading-none mt-6 text-[9rem] sm:text-[14rem]", flash && "animate-pulse")} data-testid="panel-current-code">{c?.code || "---"}</p>
        {c && <p className="text-3xl sm:text-4xl font-semibold mt-4">{c.counter || c.queue_name}</p>}
        {c?.customer_name && <p className="text-2xl text-blue-100 mt-2">{c.customer_name}</p>}
        {!audio && <button onClick={() => { setAudio(true); beep(); }} className="mt-10 flex items-center gap-2 rounded-full border border-white/30 px-5 py-2 text-sm" data-testid="panel-enable-sound"><Volume2 className="h-4 w-4" />Ativar som</button>}
      </div>
      <div className="p-8 space-y-4">
        <p className="font-mono text-sm uppercase tracking-[0.3em] text-slate-400">Últimas chamadas</p>
        {d.recent.map((t) => (
          <div key={`${t.code}${t.last_call_at}`} className="flex items-center justify-between rounded-xl bg-slate-900 p-5">
            <span className="font-mono text-4xl font-bold">{t.code}</span>
            <span className="text-right text-slate-300">{t.counter || t.queue_name}<span className="block text-xs">{fmtTime(t.last_call_at)}</span></span>
          </div>
        ))}
        <p className="pt-6 text-slate-400">Aguardando: <b className="text-white text-2xl">{d.waiting}</b></p>
      </div>
    </div>
  );
}
